import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { UiEventsService } from './ui-events.service';

@Injectable({
  providedIn: 'root',
})
export class FullScreenToggleService {
  private fullScreenSubject = new BehaviorSubject<boolean>(false);

  /**
   * Observable that emits the current full-screen status.
   */
  readonly fullScreen$ = this.fullScreenSubject.asObservable();

  constructor(private uiEvents: UiEventsService) {
    // Keep local subject in sync with legacy UiEventsService changes that
    // might come from existing parts of the app (e.g. video player).
    this.uiEvents.fullScreen$
      .pipe(distinctUntilChanged())
      .subscribe((flag) => {
        if (this.fullScreenSubject.getValue() !== flag) {
          this.fullScreenSubject.next(flag);
        }
      });
  }

  /**
   * Sets the full-screen status and forwards the value to the legacy
   * UiEventsService so existing components remain compatible.
   */
  setFullScreen(isFullScreen: boolean): void {
    if (this.fullScreenSubject.getValue() === isFullScreen) {
      return;
    }

    this.fullScreenSubject.next(isFullScreen);

    // Bridge to existing service used by video player / top menu.
    this.uiEvents.fullScreenMode(isFullScreen);
  }

  /** Convenience helper to toggle the current full-screen state. */
  toggle(): void {
    this.setFullScreen(!this.fullScreenSubject.getValue());
  }
} 